export default {
  diffusionInputs: 'Vstupy difúzie',
};
